import { useAuthContext } from "../../../Context/AuthContext";
import { useUserContext } from "../../../Context/UserContext";

export function useHasAllocationWritePermission(isAllocationEditor: boolean = true) {
  const { isDoitEmployee } = useAuthContext();
  const { userRoles } = useUserContext({ requiredRoles: true });

  const canModifyAllocations = userRoles?.allocationsAdmin || isDoitEmployee;

  if (isAllocationEditor) {
    return canModifyAllocations;
  }

  return false;
}
